import { GeoJsonLayer } from "@deck.gl/layers";
//import chroma from "chroma-js";
import { FISHING_SPOTS_URL } from "../../services/pallas";
import { OceanMask } from "./ocean-mask";

export type BestSpot = { properties: { probability: string, Prob: number, havomr: string, lokasjon: string } }

//const HEATMAP_COLOR_SCALE = chroma.scale(["#F6CEB5", "#DF9680", "#143637", "#2D957C"]).domain([0, 0.33, 0.66, 1]);

export function useBestSpotsLayer(daysAhead: number, species?: string): GeoJsonLayer<BestSpot> {
  return new GeoJsonLayer({
    id: 'fishing_spots',
    data: species ? `${FISHING_SPOTS_URL}?species=${species}&daysAhead=${daysAhead}` : FISHING_SPOTS_URL + `?daysAhead=${daysAhead}`,
    pickable: true,
    autoHighlight: true,
    lineWidthMinPixels: 1.5,
    getFillColor: [255, 219, 81, 255],
    getLineColor: [255, 255, 255, 255],
    ...OceanMask.applyOceanMask()
  });
}
